import React from "react";
import * as Sentry from "@sentry/browser";
import ReactDOM from "react-dom";
import { Amplify } from "aws-amplify";
import "./index.css";
import Base from "./views/Base/Base";
import SignUp from "./views/SignUp";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Login from "./views/Login";
import { createClient } from "./utils/graphql";
import { Provider } from "react-redux";
import { store } from "./redux";
import ForgotPassword from "./views/ForgotPassword";
import { ApolloProvider } from "@apollo/client";

// Configure aws-amplify v6 (Cognito user-pool auth) before anything touches auth.
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL,
            userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        },
    },
});

if (process.env.NODE_ENV !== "development") {
    Sentry.init({
        dsn: "https://680a0115cd601b705051ae5d6bc49863@o4507920890200064.ingest.us.sentry.io/4508100613505024",
        environment: process.env.REACT_APP_STAGE,
    });
}

createClient(process.env.REACT_APP_API_URL + "/graphql").then((client) => {
    ReactDOM.render(
        <ApolloProvider client={client}>
            <BrowserRouter>
                <Provider store={store}>
                    <React.Suspense
                        fallback={<div>loading...</div>}
                        basename={process.env.REACT_APP_ROUTER_BASE || ""}
                    >
                        <Switch>
                            <Route exact path="/login" component={Login} />
                            <Route
                                exact
                                path="/forgot-password"
                                component={ForgotPassword}
                            />
                            <Route exact path="/signup" component={SignUp} />
                            <Route path={["/", "/home"]} component={Base} />
                        </Switch>
                    </React.Suspense>
                </Provider>
            </BrowserRouter>
        </ApolloProvider>,

        document.getElementById("root")
    );
});
